<template>
  <div class="materials">
    <UserData />

    <div v-if="recommendEvents && Object.keys(recommendEvents).length">
      <div
        v-if="
          user &&
          user.specialities &&
          user.specialities.length &&
          user &&
          user.diseases &&
          user.diseases.length
        "
      >
        <div class="materials__title mb-4">Материалы для вас:</div>
        <div
          @click="openFilter"
          class="button button_pink px-12 d-inline-flex mb-4 materials__filter-button d-xl-none"
        >
          <svg
            class="mr-2"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M19.5078 12H21.6191" stroke="white" />
            <path d="M3.38281 12H15.0116" stroke="white" />
            <path d="M10.4531 5.98828H21.6206" stroke="white" />
            <path d="M3.38281 5.98828H5.96281" stroke="white" />
            <path d="M13.625 18.0117H21.62" stroke="white" />
            <path d="M3.38281 18.0117H9.12781" stroke="white" />
            <path
              d="M8.20703 8.125C9.44967 8.125 10.457 7.11764 10.457 5.875C10.457 4.63236 9.44967 3.625 8.20703 3.625C6.96439 3.625 5.95703 4.63236 5.95703 5.875C5.95703 7.11764 6.96439 8.125 8.20703 8.125Z"
              stroke="white"
            />
            <path
              d="M17.2578 14.25C18.5005 14.25 19.5078 13.2426 19.5078 12C19.5078 10.7574 18.5005 9.75 17.2578 9.75C16.0152 9.75 15.0078 10.7574 15.0078 12C15.0078 13.2426 16.0152 14.25 17.2578 14.25Z"
              stroke="white"
            />
            <path
              d="M11.375 20.2617C12.6176 20.2617 13.625 19.2544 13.625 18.0117C13.625 16.7691 12.6176 15.7617 11.375 15.7617C10.1324 15.7617 9.125 16.7691 9.125 18.0117C9.125 19.2544 10.1324 20.2617 11.375 20.2617Z"
              stroke="white"
            />
          </svg>
          Фильтр
        </div>
        <MaterialsCategories class="mb-7" />
        <div
          class="mb-12"
          v-if="recommendationsList.events && recommendationsList.events.length"
        >
          <div class="materials__item-title mb-3">Мероприятия</div>
          <Event
            v-for="i in eventsListLength"
            :key="`ev${i}`"
            :event="recommendationsList.events[i - 1]"
            class="mb-6"
            large
            style="background-color: #fff"
          />
          <div
            class="materials-page__load button button_pink"
            v-if="recommendationsList.events.length > listLength"
            @click="loadMore()"
          >
            Загрузить ещё
            <span class="ml-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 12.7501L4.5 12.0001H3V12.7501H4.5ZM19.5 12.7501C19.5 16.8923 16.1421 20.2501 12 20.2501L12 21.7501C16.9706 21.7501 21 17.7207 21 12.7501L19.5 12.7501ZM12 20.2501C7.85786 20.2501 4.5 16.8923 4.5 12.7501H3C3 17.7207 7.02944 21.7501 12 21.7501L12 20.2501ZM12 5.25012C16.1421 5.25012 19.5 8.60799 19.5 12.7501L21 12.7501C21 7.77956 16.9706 3.75012 12 3.75012V5.25012ZM7.56864 6.69856C8.8101 5.78779 10.3412 5.25012 12 5.25012V3.75012C10.0114 3.75012 8.17143 4.39596 6.68136 5.48912L7.56864 6.69856Z"
                  fill="#B36697"
                />
                <path
                  d="M8.08391 1.05776L6.37094 6.61929L11.9325 8.33225"
                  stroke="#B36697"
                  stroke-width="1.5"
                />
              </svg>
            </span>
          </div>
        </div>
        <MaterialsSlider
          :key="`text_${recommendationsList.archive_events.length}`"
          v-if="
            recommendationsList.archive_events &&
            recommendationsList.archive_events.length
          "
          :title="'Архив мероприятий'"
          :count="recommendationsList.archive_events.length"
        >
          <template #items>
            <Project
              v-for="(item, i) in recommendationsList.archive_events"
              :item="{ ...item, type: { name: 'Архив мероприятий' } }"
              :key="i"
              @watchLater="
                watchLater(
                  item.watch_later ? 'DELETE' : 'POST',
                  item.id,
                  'archive_event'
                )
              "
              @favorite="
                favorite(
                  item.favorite ? 'DELETE' : 'POST',
                  item.id,
                  'archive_event'
                )
              "
            />
          </template>
        </MaterialsSlider>
      </div>

      <div
        class="favorites__list-container"
        v-if="
          user &&
          user.specialities &&
          user.specialities.length &&
          user &&
          user.diseases &&
          user.diseases.length &&
          !notEmpty
        "
      >
        <div class="favorites__title">Здесь пока пусто</div>
        <div class="favorites__descr">
          Чтобы увидеть список материалов для вас - выберите хотя бы одну
          терапевтическую область и одну нозологию
        </div>
      </div>

      <div
        class="favorites__list-container"
        v-else-if="
          user &&
          user.specialities &&
          !user.specialities.length &&
          user &&
          user.diseases &&
          !user.diseases.length
        "
      >
        <div class="favorites__title">Здесь пока пусто</div>
        <div class="favorites__descr">
          Чтобы увидеть Материалы для вас - пройдите тест
        </div>
        <div
          class="favorites__btn button button_pink mt-6"
          @click="toSettings({ name: 'MaterialsSettings' })"
        >
          Настроить Мой AZ-MOST
        </div>
      </div>
    </div>
    <div v-else class="preloader">
      <Preloader class="" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import UserData from "../../components/pageComponents/cabinet/UserData.vue";
import MaterialsCategories from "../../components/pageComponents/cabinet/EventsCategories.vue";
import MaterialsSlider from "../../components/pageComponents/cabinet/MaterialsSlider.vue";
import Project from "@/components/pageComponents/Project.vue";
import Event from "../../components/main/events/Event.vue";
import { bus } from "@/main";
import Preloader from "@/components/Preloader.vue";
import pageVisit from "@/mixins/pageVisit";
export default {
  components: {
    UserData,
    MaterialsCategories,
    MaterialsSlider,
    Project,
    Event,
    Preloader,
  },
  name: "Events",
  data: () => ({
    count: 3,
    listLength: 6,
  }),
  mixins: [pageVisit],
  computed: {
    ...mapGetters(["user", "recommendEvents"]),
    eventsListLength() {
      return this.listLength > this.recommendationsList.events.length
        ? this.recommendationsList.events.length
        : this.listLength;
    },
    archiveEventsListLength() {
      return this.listLength > this.recommendationsList.archive_events.length
        ? this.recommendationsList.archive_events.length
        : this.listLength;
    },
    currentNosologys: {
      get() {
        return this.$store.state.materialsFilter.materialsNosology;
      },
      set(value) {
        this.$store.commit("updateMatNos", value);
      },
    },
    currentDiseases: {
      get() {
        return this.$store.state.materialsFilter.materialsDisease;
      },
      set(value) {
        this.$store.commit("updateMatDis", value);
      },
    },
    notEmpty() {
      return Object.keys(this.recommendationsList).some(
        (r) => this.recommendationsList[r].length
      );
    },
    notEmptyTabs() {
      return Object.keys(this.recommendationsList).filter(
        (el) => this.recommendationsList[el].length
      );
    },
    recommendationsList() {
      return {
        events: this.recommendEvents.events.filter((el) =>
          el.nosology.some((r) => this.currentNosologys.includes(r.id))
        ),
        archive_events: this.recommendEvents.archive_events.filter((el) =>
          el.nosology.some((r) => this.currentNosologys.includes(r.id))
        ),
      };
    },
  },
  methods: {
    ...mapActions([
      "getRecommendEvents",
      "fetchProjectFavorite",
      "fetchArchiveEventsFavorite",
      "fetchArchiveEventsWatchLater",
      "fetchProjectWatchLater",
    ]),
    toSettings(to) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "set my AZ-MOST up", {
          "set my AZ-MOST up": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(to).catch(() => {});
    },
    loadMore() {
      this.listLength =
        this.listLength + this.count > this.recommendationsList.events.length
          ? this.recommendationsList.events.length
          : this.listLength + this.count;
    },
    async watchLater(method, slug, type) {
      switch (type) {
        case "project":
          await this.fetchProjectWatchLater({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
        case "archive_event":
          await this.fetchArchiveEventsWatchLater({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
      }
      await this.getRecommendEvents(this.user.id);
    },
    async favorite(method, slug, type) {
      switch (type) {
        case "project":
          await this.fetchProjectFavorite({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
        case "archive_event":
          await this.fetchArchiveEventsFavorite({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
      }
      await this.getRecommendEvents(this.user.id);
    },
    openFilter() {
      bus.$emit("openFilter");
    },
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: "",
          brand_id: "",
          content_date: "",
          content_id: "",
          content_name: "Мероприятия",
          content_type: "Мероприятия",
          nosology_name: "",
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Мероприятия",
          page_type: "Мероприятия",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
  mounted() {
    if (this.user && Object.keys(this.user).length) {
      this.getRecommendEvents(this.user.id);
    }
   
  },
  watch: {
    user() {
      if (
        this.user &&
        Object.keys(this.user).length &&
        this.recommendEvents &&
        !Object.keys(this.recommendEvents).length
      ) {
        this.getRecommendEvents(this.user.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.medication-item {
  height: 100%;
}

.materials {
  width: 100%;
  min-height: 100%;
  background-color: #f8f8f8;
  padding-left: 32px;
  padding-top: 48px;
  padding-bottom: 80px;
  z-index: auto;
  position: relative;
  @media screen and (max-width: 1220px) {
    padding-left: 0;
  }

  &__filter-button {
    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  &__title {
    margin-bottom: 24px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
    @media screen and (max-width: 767px) {
      font-size: 18px;
      line-height: 22px;
    }
  }

  &__item-title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }
}

.materials-page {
  &__load {
    width: 175px;
    @media screen and (max-width: 767px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
}

.favorites {
  background-color: #f8f8f8;
  padding-left: 32px;
  padding-top: 48px;
  padding-bottom: 80px;
  z-index: 1000;
  position: relative;
  @media screen and (max-width: 1220px) {
    padding-left: 0;
  }

  &__title {
    margin-bottom: 24px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }
  &__descr {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  &__btn {
    max-width: fit-content;
    @media screen and (max-width: 767px) {
      width: 100%;
      max-width: none;
    }
  }
}
</style>
<style lang="scss">
.materials {
  & .preloader {
    width: 100%;
    height: calc(100% - 48px - 80px);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f8;

    & .lds-ring {
      width: 100px;
      height: 100px;

      & div {
        border-width: 6px;
        border-color: #830051 transparent transparent transparent;
      }
    }
  }
}
</style>